import { render, staticRenderFns } from "./ProcessingToolbox.vue?vue&type=template&id=79a0c6f7&scoped=true"
import script from "./ProcessingToolbox.vue?vue&type=script&lang=js"
export * from "./ProcessingToolbox.vue?vue&type=script&lang=js"
import style0 from "./ProcessingToolbox.vue?vue&type=style&index=0&id=79a0c6f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0c6f7",
  null
  
)

export default component.exports